export default class Portfolio {
	public  formEl: HTMLElement = document.getElementById('portfolioForm');
	private filterEl: NodeListOf<Element> = document.querySelectorAll('.filter');
	private tabTriggerEl: NodeListOf<Element> = document.querySelectorAll('.filter__trigger');
	private filterOptionsEl: NodeListOf<Element> = document.querySelectorAll('.filter__tray');


	private filterHandler = (event: Event) => {
		event.preventDefault();
		const element: HTMLElement = event.currentTarget as HTMLElement;
		const relatedId: string = element.getAttribute('data-related-id');
		this.showFilterOptions(relatedId);
	}
	private buildFilterHandlers(): void {
		for (let i: number = 0, l:number = this.tabTriggerEl.length; i < l; i++) {
			const element: Element = this.tabTriggerEl[i];
			element.addEventListener('click', this.filterHandler);
		}
	}
	private buildChangeHandler(): void {
		this.formEl.addEventListener('change', (event: Event) => {
			this.hideFilterOptions();
		});
	}

	private hideFilterOptions(): void {
		for (let i: number = 0, l: number = this.filterOptionsEl.length; i < l; i++) {
			this.filterEl[i].classList.remove('target');
			this.filterOptionsEl[i].classList.remove('target');
		}
	}
	private showFilterOptions(relatedId: string): void {
		const targetTab: Element = document.getElementById(relatedId);
		const isActive: boolean = targetTab.classList.contains('target');

		this.hideFilterOptions();

		/* only activate if it's not active */
		if (!isActive) {
			console.log(targetTab.parentElement);
			targetTab.parentElement.classList.add('target');
			targetTab.classList.add('target');
		}
	}

	constructor() {
		if (!this.formEl) {
			return;
		}
		this.buildFilterHandlers();
		this.buildChangeHandler();
	}
}
